<p [hidden]="!loading.busy">
  <wl-busy [show]="loading.busy"></wl-busy>
</p>

<p *ngIf="loading.message && !loading.success" class="text-danger">
  {{ loading.message }}
</p>

<p-table [showGridlines]="true" #eventPaymentMethodsDataGrid [rows]="100" [value]="paymentMethods" [hidden]="loading.busy || !loading.success">
  <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
    <SortAltIcon *ngIf="sortOrder === 0">
      <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
    </SortAltIcon>
    <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
      <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
    </SortAmountUpAltIcon>
    <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
      <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
    </SortAmountDownIcon>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th>{{ 'events.settings.payment-methods.payment-method-column-header' | translate | titlecase }}</th>
      <th>{{ 'events.settings.payment-methods.available-online-column-header' | translate | titlecase }}</th>
      <th class="text-right">{{ 'events.settings.payment-methods.fee-column-header' | translate | titlecase }}</th>
      <th></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-dataItem>
    <tr>
      <td>{{ dataItem.PaymentMethodDescr }}</td>
      <td>
        <input
          type="checkbox"
          *ngIf="dataItem.Accept"
          disabled
          checked
          [title]="'events.settings.payment-methods.available-online-where-to-change' | translate"
        />
        <input
          type="checkbox"
          *ngIf="!dataItem.Accept"
          disabled
          [title]="'events.settings.payment-methods.available-online-where-to-change' | translate"
        />
      </td>
      <td class="text-right">
        <span [hidden]="dataItem.FeeType != 0">{{ dataItem.Fee | currency }}</span>
        <span [hidden]="dataItem.FeeType != 1">{{ dataItem.Fee | atlasPercent }}</span>
      </td>
      <td>
        <button pButton type="button" class="btn btn-primary" (click)="editEventItemPaymentMethod(dataItem)" icon="pi pi-pencil">
          {{ 'events.settings.payment-methods.edit-event-payment-method-button-label' | translate | titlecase }}
        </button>
      </td>
    </tr>
  </ng-template>
</p-table>
<p-progressSpinner *ngIf="loading"></p-progressSpinner>

<p-dialog
  #paymentMethodsModal
  modal="true"
  [(visible)]="showModal"
  [closable]="true"
  styleClass="atlas-dialog-l"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  <ng-template pTemplate="header">
    <h4 class="modal-title">{{ 'events.settings.payment-methods.title' | translate | titlecase }}</h4>
  </ng-template>

  <div class="container-fluid">
    <div class="form-horizontal">
      <div class="form-group">
        <label class="col-sm-3 control-label">
          {{ 'events.settings.payment-methods.payment-method-label' | translate | titlecase }}
        </label>
        <div class="col-sm-9">
          <div class="form-control-static">
            {{ selectedEventPaymentMethod.PaymentMethodDescr | titlecase }}
          </div>
        </div>
      </div>

      <div class="form-group">
        <label class="col-sm-3 control-label" for="available-to-public-cb">
          {{ 'events.settings.payment-methods.available-to-public-label' | translate | titlecase }}
        </label>
        <div class="col-sm-9">
          <div class="form-control-static">
            <input
              type="checkbox"
              class="text-center"
              id="available-to-public-cb"
              [(ngModel)]="selectedEventPaymentMethod.Accept"
              (click)="handleAvailableToPublicChange($event)"
              *ngIf="selectedEventPaymentMethod.PaymentMethodId != paymentMethodEnum.CashCheck"
            />

            <span *ngIf="selectedEventPaymentMethod.PaymentMethodId == paymentMethodEnum.CashCheck">{{
              'events.settings.payment-methods.not-available-to-public' | translate
            }}</span>
          </div>
        </div>
      </div>

      <div class="form-group" *ngIf="selectedEventPaymentMethod.PaymentMethodId != paymentMethodEnum.CashCheck">
        <label class="col-sm-3 control-label">
          {{ 'events.settings.payment-methods.applies-to-label' | translate | titlecase }}
        </label>
        <div class="col-sm-9">
          <div class="form-control-static">
            <div *ngIf="loadingEventItemPaymentMethods">
              <wl-busy [show]="loadingEventItemPaymentMethods"></wl-busy>
            </div>
            <div
              [hidden]="loadingEventItemPaymentMethods"
              *ngFor="let eventItemPaymentMethod of selectedEventPaymentMethod.EventItemPaymentMethods"
            >
              <label>
                <input type="checkbox" class="text-center" [(ngModel)]="eventItemPaymentMethod.Accept" />
                {{ eventItemPaymentMethod.EventItemDescr }}
              </label>
            </div>
          </div>
        </div>
      </div>

      <div class="form-group">
        <label class="col-sm-3 control-label">
          {{ 'events.settings.payment-methods.fee-type-label' | translate | titlecase }}
        </label>

        <div class="col-sm-9">
          <div class="form-control-static">
            <div *ngFor="let feeType of feeTypes">
              <label
                ><input
                  type="radio"
                  name="paymentTypeFeeTypes"
                  [(ngModel)]="selectedEventPaymentMethod.FeeType"
                  [value]="feeType.FeeTypeId"
                />
                {{ feeType.FeeType }}</label
              >
            </div>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-3 control-label">
          {{ 'events.settings.payment-methods.fee-amount-label' | translate | titlecase }}
        </label>
        <div class="col-sm-4 col-lg-2">
          <div class="input-group">
            <div class="input-group-addon" *ngIf="selectedEventPaymentMethod.FeeType == 0">
              <wl-currency-symbol></wl-currency-symbol>
            </div>
            <input class="text-right form-control" type="number" step="0.01" [(ngModel)]="selectedEventPaymentMethod.Fee" />
            <div class="input-group-addon" *ngIf="selectedEventPaymentMethod.FeeType == 1"><span>%</span></div>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-3 control-label">
          {{ 'events.settings.payment-methods.revenue-item-label' | translate | titlecase }}
        </label>
        <div class="col-sm-9">
          <wl-revenue-item-selector [(ngModel)]="selectedEventPaymentMethod.ItemNum"></wl-revenue-item-selector>
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-3 control-label">
          {{ 'events.settings.payment-methods.fee-description-label' | translate | titlecase }}
        </label>

        <div class="col-sm-9">
          <input class="form-control" type="text" [(ngModel)]="selectedEventPaymentMethod.FeeDescr" />
        </div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div>
      <wl-save-cancel-actions 
  [isSaving]="saving"
  [isSaveDisabled]="saving" 
  [error]="saveError"
  (onSave)="saveEventItemPaymentMethod()" 
  (onCancel)="cancel()">
</wl-save-cancel-actions>
    </div>
  </ng-template>
</p-dialog>
